import { Injectable, signal } from '@angular/core';
import { Observable, Subject } from 'rxjs';

/** Carries an open request, plus an optional composer seed, to the layout that owns the panel. */
@Injectable({ providedIn: 'root' })
export class AlloPanelService {
  private readonly requests = new Subject<void>();
  /** The layout listens and opens the right sidenav on its chat tab. */
  readonly openRequests$: Observable<void> = this.requests.asObservable();

  private readonly prompt = signal('');
  /** Seed for the docked composer. PREFILL only — the reader decides whether to send. */
  readonly initialPrompt = this.prompt.asReadonly();

  open(initialPrompt = ''): void {
    this.prompt.set(initialPrompt);
    this.requests.next();
  }

  /** Drop the seed once the reader moves to a new or different thread. */
  clearPrompt(): void {
    this.prompt.set('');
  }
}
